// extracted by mini-css-extract-plugin
export default {"hover-container":"NavbarLink_hover-container__LrYDX","nav-link":"NavbarLink_nav-link__r0nu1"};